const notificationDetailModal = {
  from: "Frá",
};

export default notificationDetailModal;
